import { AvailabilityType } from '../models/checkout.model';
import { AvailabilityTypePageConfig, JourneyZone } from '../models/checkout-journey.types';
import { BOOKING_AVAILABILITY_TYPE_CONFIG } from './availability-type-booking';
import { REQUEST_AVAILABILITY_TYPE_CONFIG } from './availability-type-request';

// No LIMITED_BOOKING entry: BasketService refuses those timeslots, so they never reach checkout.
export const AVAILABILITY_TYPE_CONFIGS: Record<Exclude<AvailabilityType, 'LIMITED_BOOKING'>, AvailabilityTypePageConfig[]> = {
  BOOKING: BOOKING_AVAILABILITY_TYPE_CONFIG,
  REQUEST: REQUEST_AVAILABILITY_TYPE_CONFIG,
};

export function getAvailabilityTypeZoneConfig<T>(
  availabilityType: AvailabilityType | null,
  pageRoute: string,
  zone: JourneyZone,
): T | undefined {
  if (!availabilityType || availabilityType === 'LIMITED_BOOKING') return undefined;

  const configs = AVAILABILITY_TYPE_CONFIGS[availabilityType];
  if (!configs) return undefined;

  const pageConfig = configs.find((c) => c.pageRoute === pageRoute);
  if (!pageConfig?.zoneConfig) return undefined;

  return pageConfig.zoneConfig[zone] as T | undefined;
}
